export const isGeoDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;
  const w = window as unknown as { __GEO_DEBUG__?: boolean; localStorage?: Storage };
  if (w.__GEO_DEBUG__ === true) return true;
  try {
    return window.localStorage.getItem('geoDebug') === '1';
  } catch {
    return false;
  }
};

export const geoDebugLog = (prefix: string, message: string, meta?: Record<string, unknown>) => {
  if (!isGeoDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(prefix, message, meta ?? {});
};
